export default __webpack_public_path__ + "media/images/symbols/arrow-up-c9820603aa13690d707217a68122ba92.svg";